import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

export const dashboardReport = createAsyncThunk(
    "report/dashboardReport",
    async (projectId, { rejectWithValue }) => {
        try {            
            const response = await POST(
                "report", 
                `${apiUrl.dashboard_report}/dashboard/${projectId}`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const getProjectReports = createAsyncThunk(
    'report/getProjectReports',
    async (projectId, { rejectWithValue }) => {
        try {
            const response = await GET(
                "report",
                `${apiUrl.project_report}/${projectId}`
            );

            return response?.data;            
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const makeReport = createAsyncThunk(
    "report/generateReport",
    async (projectId, { rejectWithValue }) => {
        try {           
            const response = await POST(
                "report", 
                `${apiUrl.project_report}/${projectId}`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

const reportSlice = createSlice({
    name: "report",
    initialState: {
        data: [],
        loading: false,
        error: null,
        reports: []
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(dashboardReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(dashboardReport.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data;
            })
            .addCase(dashboardReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getProjectReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProjectReports.fulfilled, (state, action) => {
                state.loading = false;
                state.reports = action.payload?.data;
            })
            .addCase(getProjectReports.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default reportSlice.reducer;